/* eslint-disable no-underscore-dangle */

class ArrayRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("array-column");
        this._rootElem.component = this._model;

        this._registerListeners();

        this.render();
    }

    _shutdown() {
        return new Promise((resolve /* ,reject */) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("Update", (this._onUpdate = this._onUpdate.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("Update", this._onUpdate);
    }

    render() {
        return new Promise((resolve /* ,reject */) => {
            this._updateValue();
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    _onUpdate() {
        this._updateValue();
    }

    _sanitize(value) {
        if (!value) {
            return "";
        }
        if (Array.isArray(value)) {
            return value
                .filter((v) => v !== undefined && v !== null)
                .map((v) => (typeof v === "object" ? JSON.stringify(v) : String(v)))
                .join(", ");
        }
        return typeof value === "object" ? JSON.stringify(value) : String(value);
    }

    _updateValue() {
        const value = this._model.getValue();
        this._rootElem.innerText = this._sanitize(value);
    }
}

export default ArrayRenderer;
